export function useCache<T>(ttlInSeconds: number) {
	const cache = new Map<string, { data: T; expiresAt: number }>()

	function clearExpired() {
		const now = Date.now()

		for (const [key, entry] of cache.entries()) {
			if (now > entry.expiresAt) {
				cache.delete(key)
			}
		}
	}

	async function get(key: string, freshValueGetter: () => Promise<T>): Promise<T> {
		clearExpired()

		if (cache.has(key)) {
			return cache.get(key)?.data as T
		}

		const freshValue = await freshValueGetter()

		cache.set(key, {
			data: freshValue,
			expiresAt: Date.now() + 1000 * ttlInSeconds
		})

		return freshValue
	}

	function remove(keyOrRegex: string | RegExp) {
		if (keyOrRegex instanceof RegExp) {
			for (const [key] of cache) {
				if (keyOrRegex.test(key)) {
					cache.delete(key)
				}
			}
		} else {
			cache.delete(keyOrRegex)
		}
	}

	function clear() {
		cache.clear()
	}

	return {
		get,
		remove,
		clear
	}
}
